export default {"src":"/_next/static/media/cube3d_grey.0d762fff.svg","height":18,"width":18};